// Author thq
// Date 2020-12-21 22:58:17

class EmAclLocation {
constructor({
        id = null,
        name = '',
        level = '',
        nodeCode = '',
        parentId = '',
        seq = '',
        elocId = '',
        remark = '',
        externalId = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.level = level;
    this.nodeCode = nodeCode;
    this.parentId = parentId;
    this.seq = seq;
    this.elocId = elocId;
    this.remark = remark;
    this.externalId = externalId;
}
}

function newEntity() {
return new EmAclLocation();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'name',
        label: 'label.em.admin.emAclLocation.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'level',
        label: 'label.em.admin.emAclLocation.grid.level',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'nodeCode',
        label: 'label.em.admin.emAclLocation.grid.nodeCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'parentName',
        label: 'label.em.admin.emAclLocation.grid.parentName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'seq',
        label: 'label.em.admin.emAclLocation.grid.seq',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'elocName',
        label: 'label.em.admin.emAclLocation.grid.elocName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.admin.emAclLocation.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        },
        {
        key: 'externalId',
        label: 'label.em.admin.emAclLocation.grid.externalId',
        sortable: true,
        form: {
        type: 'input'
        }
        }
    ])}

const filter = {
    nameFilter : "",
    levelFilter : "",
    nodeCodeFilter : "",
    parentIdFilter : "",
    seqFilter : "",
    elocIdFilter : "",
    externalIdFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.em.admin.emAclLocation.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'parentIdFilter',
        label: 'label.em.admin.emAclLocation.filter.parentId',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'emAclLocation'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'elocIdFilter',
        label: 'label.em.admin.emAclLocation.filter.elocId',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'emAclLocationType'
            ,showLabelSelectOne: true
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.em.admin.emAclLocation.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'parentId',
        label: 'label.em.admin.emAclLocation.entity.parentId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'emAclLocation'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'seq',
        label: 'label.em.admin.emAclLocation.entity.seq',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'elocId',
        label: 'label.em.admin.emAclLocation.entity.elocId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'emAclLocationType'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'remark',
        label: 'label.em.admin.emAclLocation.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        },
        {
        key: 'externalId',
        label: 'label.em.admin.emAclLocation.entity.externalId',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        }
]

export {EmAclLocation, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
